// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1HTnI","rightAdornment":"Header_rightAdornment__3foLC"};